import { render } from "./SelectBackSearchableElement.vue?vue&type=template&id=316ab1eb&scoped=true"
import script from "./SelectBackSearchableElement.vue?vue&type=script&lang=js"
export * from "./SelectBackSearchableElement.vue?vue&type=script&lang=js"

import "./SelectBackSearchableElement.vue?vue&type=style&index=0&id=316ab1eb&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316ab1eb"]])

export default __exports__